import TextField from '@material-ui/core/TextField'
import React from 'react'
import { nbsStr } from '../../../../services/lib/utils/helpers'

export const SupplierManagementColumnModel = (): any => {
  return [
    {
      title: 'Supplier Name',
      field: 'suplierName',
      editComponent: (props:any) => (
        <TextField
          value={props.value}
        fullWidth={true}
        multiline={true}
        onChange={e => props.onChange(e.target.value)}
        />)	
    },
    {
      title: 'With Qualification',
      field: 'suplierType',
      editable: 'never',
      lookup: {0: 'No', 1: 'Yes'}
    },
    {
      title: 'Qualification',
      field: 'qualification',
      editable: 'never',
      filtering: false,
      render: (rowData: any) => {
        return (
          <ul>
            {
              rowData.qualification?.map((row: any, index: number) => {
                return (
                  <li key={index.toString()}>
                    {nbsStr(row.qualificationName + ' - ')}
                    <span style={row.isExpiredAlert ? {color: 'red', fontWeight: 'bold'} : {}}>&nbsp;{nbsStr(row.expDate)}</span>
                  </li>
                )
              })
            }
          </ul>
        )
      },
    },
    {
      title: 'Address',
      field: 'address',
      editComponent: (props:any) => (
        <TextField
          value={props.value}
        fullWidth={true}
        multiline={true}
        onChange={e => props.onChange(e.target.value)}
        />)	      
    },
    {
      title: 'Phone',
      field: 'phone',
      editComponent: (props:any) => (
        <TextField
          value={props.value}
        fullWidth={true}
        multiline={true}
        onChange={e => props.onChange(e.target.value)}
        />)	      
    },
    {
      title: 'Email',
      field: 'email',
      editComponent: (props:any) => (
        <TextField
          value={props.value}
        fullWidth={true}
        multiline={true}
        onChange={e => props.onChange(e.target.value)}
        />)	      
    },
  ]
}
